module.exports = __webpack_public_path__ + "static/media/BugsyPumpkinCarvingPattern.9d9ccc00.png";